import strFunc from "@/lib/lyg/string";
import DateFunc from '@/lib/lyg/date_func';
import UserGroupDataFunc from "@/pcomponents/common/content/list/user/search/tab_area/func/group_data";
import DeskUseDataFunc from "@/pcomponents/common/content/edu/desk/func/desku_func";
import TStuTodoBaseFunc from "@/pcomponents/common/content/tea/tstu_todo/func/base_func";
import DailyReportDataFunc from "@/pcomponents/common/content/edu/daily_report/func/data_func";

class DailyDataFunc {
  static get_stu_list_of_setting_default_daily_info_arr(inData: any) {
    let opt_obj = {
      info_arr: [],
      select_date: "",
      tab_id: "lecture",
      user: null,
      now_ymdhis: "",
      writer_seq: "",
      writer_name: "",
      is_order_by_desk_use: false,
      is_filter_todo_complete: false,
      is_filter_desk_complete: false,
      is_filter_absent: false,
      is_only_now_desk: false,
      ...inData,
    };
    let info_arr = opt_obj.info_arr;

    if (opt_obj["is_only_now_desk"]) {
      opt_obj["is_filter_todo_complete"] = true;
    }
    //걸러내기
    let filter_user_arr: any = [];
    for (let u_i = 0; u_i < info_arr.length; u_i++) {
      let info = info_arr[u_i];
      let is_add_info = true;
      let now_desk_subject_arr = [];
      if (opt_obj["is_only_now_desk"]) {
        let now_desku_arr: any = [];
        //현재 데스크 사용중인 학생만
        if (info.desk_use_arr && info.desk_use_arr.length > 0) {
          now_desku_arr = DeskUseDataFunc.get_now_desku_arr({
            now_ymdhis: opt_obj.now_ymdhis,
            desku_arr: info.desk_use_arr,
          });
        }
        
        info.now_desku_arr = now_desku_arr;
        if (now_desku_arr == 0) {
          is_add_info = false;
        } else {
          for (let nd_i = 0; nd_i < now_desku_arr.length; nd_i++) {
            let now_desk_info = now_desku_arr[nd_i];
            if (!strFunc.is_empty(now_desk_info["a_subject"])) {
              if (strFunc.str_in_array(now_desk_info["a_subject"], now_desk_subject_arr) == -1) {
                now_desk_subject_arr.push(now_desk_info["a_subject"]);
              }
            }
          }
        }
      }
      info.now_desk_subject_arr = now_desk_subject_arr;

      if (is_add_info) {
        filter_user_arr.push(info);
      }
    }
    info_arr = filter_user_arr;

    let group_data_arr = UserGroupDataFunc.get_cardbox_group_data_arr({
      select_date: opt_obj.select_date,
      info_arr: info_arr,
      tab_id: opt_obj.tab_id,
      now_ymdhis: opt_obj.now_ymdhis,
      is_only_now_desk: opt_obj.is_only_now_desk,
      is_order_by_desk_use: opt_obj.is_order_by_desk_use,
      is_filter_todo_complete: opt_obj.is_filter_todo_complete,
      is_filter_desk_complete: opt_obj.is_filter_desk_complete,
      is_filter_absent: opt_obj.is_filter_absent,
    });

    let select_date_json = DateFunc.get_date_json(new Date(opt_obj["select_date"]));
    let select_day_str = DateFunc.get_day_str_by_day_num(select_date_json.day);
    let pre_date_change_num = -1;
    if (select_date_json.day == 1) {
      //일요일이면 3일뒤로이동(금요일부터 보이게한다.)
      pre_date_change_num = -3;
    }
    let pre_date_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(opt_obj["select_date"]), 'day', pre_date_change_num), "Y-m-d");

    let this_obj = this;
    //그룹 돌리면서 daily_info_arr 없는것 생성.
    for (let group_i = 0; group_i < group_data_arr.length; group_i++) {
      let group_info = group_data_arr[group_i];
      let lecture_info = group_info["lecture_info"];
      let stu_info_arr = group_info["info_arr"];
      for (let stu_i = 0; stu_i < stu_info_arr.length; stu_i++) {
        let info = stu_info_arr[stu_i];
        let row_last_daily_report_arr = [];
        if (info.last_daily_report_arr) {
          row_last_daily_report_arr = info.last_daily_report_arr;
        }
        let last_daily_info = this.get_last_daily_info_by_lecture({
          stu_info: info,
          lecture_info: lecture_info,
          last_daily_report_arr: row_last_daily_report_arr,
          subject: group_info["subject"],
        });

        let daily_info = this_obj.get_daily_info_of_date({
          date_str: opt_obj.select_date,
          pre_date_str: pre_date_str,
          // is_now_date: true,
          last_daily_info: last_daily_info,
          lecture_time_str: group_info["time_str"],
          info: info,
          lecture_info: lecture_info,
          user: opt_obj.user,
          writer_seq: opt_obj.writer_seq,
          writer_name: opt_obj.writer_name,
          subject: group_info["subject"],
        });

        if (strFunc.is_empty(daily_info["a_seq"])) {
          //daily_report_arr에 추가
          for (let i = 0; i < info_arr.length; i++) {
            if (info_arr[i]["a_seq"] == info["a_seq"]) {
              if (strFunc.is_empty(info_arr[i]["daily_report_arr"])) {
                info_arr[i]["daily_report_arr"] = [];
              }
              info_arr[i]["daily_report_arr"].push(daily_info);
            }
          }
        }

        let daily_prescribe_info: any = this_obj.get_daily_prescribe_of_subject({
          stu_info: info,
          date_str: opt_obj.select_date,
          pre_date_str: pre_date_str,
          subject: lecture_info ? lecture_info["a_subject"] : "",
          user: opt_obj.user,
          writer_seq: opt_obj.writer_seq,
          writer_name: opt_obj.writer_name,
        });

        if (strFunc.is_empty(daily_prescribe_info["a_seq"])) {
          //daily_prescribe_arr 추가
          for (let i = 0; i < info_arr.length; i++) {
            if (info_arr[i]["a_seq"] == info["a_seq"]) {
              if (strFunc.is_empty(info_arr[i]["daily_prescribe_arr"])) {
                info_arr[i]["daily_prescribe_arr"] = [];
              }
              info_arr[i]["daily_prescribe_arr"].push(daily_prescribe_info);
            }
          }
        }

        let tstu_todo_info = this_obj.get_tstu_todo_of_subject({
          stu_info: info,
          date_str: opt_obj.select_date,
          pre_date_str: pre_date_str,
          subject: lecture_info ? lecture_info["a_subject"] : "",
          user: opt_obj.user,
          writer_seq: opt_obj.writer_seq,
          writer_name: opt_obj.writer_name,
        });

        if (strFunc.is_empty(tstu_todo_info["a_seq"])) {
          //tstu_todo_arr 추가
          for (let i = 0; i < info_arr.length; i++) {
            if (info_arr[i]["a_seq"] == info["a_seq"]) {
              if (strFunc.is_empty(info_arr[i]["tstu_todo_arr"])) {
                info_arr[i]["tstu_todo_arr"] = [];
              }
              info_arr[i]["tstu_todo_arr"].push(tstu_todo_info);
            }
          }
        }
      }
    }


    //출석정보체크
    info_arr = this.get_stu_list_of_attend_data_setting({
      info_arr: info_arr,
    });

    return info_arr;
  };

  static get_daily_prescribe_of_subject(inData: any) {
    let opt_obj = {
      stu_info: null,
      date_str: "",
      pre_date_str: "",
      subject: "",
      user: {},
      writer_seq: "",
      writer_name: "",
      ...inData
    };
    let user = opt_obj["user"];
    let stu_info = opt_obj["stu_info"];
    let daily_prescribe_info: any = {
      a_ymd: strFunc.getNumber2(opt_obj["date_str"]),
      a_seq: "",
      a_write_date: opt_obj["date_str"],
      a_stu_seq: stu_info["a_seq"],
      a_stu_name: stu_info["a_user_name"],
      a_writer_seq: "",
      a_writer_name: "",
      a_subject: opt_obj["subject"],
      a_issue: "",
      a_homework_plan: "",
      a_homework_amount: "",
      a_progress_plan: "",
      a_progress_amount: "",
      a_memo: "",
    };

    if (!strFunc.is_empty(opt_obj["writer_seq"])) {
      daily_prescribe_info["a_writer_seq"] = opt_obj["writer_seq"];
    }
    if (!strFunc.is_empty(opt_obj["writer_name"])) {
      daily_prescribe_info["a_writer_name"] = opt_obj["writer_name"];
    }
    if (strFunc.is_empty(opt_obj["a_writer_seq"]) && user) {
      daily_prescribe_info["a_writer_seq"] = user.user_seq;
      daily_prescribe_info["a_writer_name"] = user.user_name;
    }

    let daily_prescribe_info_last: any = {};
    if (stu_info.daily_prescribe_last_arr && stu_info.daily_prescribe_last_arr.length > 0) {
      for (let i = 0; i < stu_info.daily_prescribe_last_arr.length; i++) {
        let row_prescribe_last = stu_info.daily_prescribe_last_arr[i];
        if (row_prescribe_last["a_stu_seq"] == stu_info["a_seq"]
          && row_prescribe_last["a_subject"] == opt_obj["subject"]
        ) {
          daily_prescribe_info_last = row_prescribe_last;
        }
      }
    }

    let is_exist_pre = false;
    if (stu_info.daily_prescribe_arr && stu_info.daily_prescribe_arr.length > 0) {
      for (let i = 0; i < stu_info.daily_prescribe_arr.length; i++) {
        let row_daily_prescribe_info = stu_info.daily_prescribe_arr[i];
        if (row_daily_prescribe_info["a_stu_seq"] == stu_info["a_seq"]
          && row_daily_prescribe_info["a_write_date"] == opt_obj["date_str"]
          && row_daily_prescribe_info["a_subject"] == opt_obj["subject"]) {
          daily_prescribe_info = {
            ...daily_prescribe_info,
            ...row_daily_prescribe_info,
          };
          is_exist_pre = true;
        }
      }
    }
    if (is_exist_pre == false) {
      daily_prescribe_info = {
        ...daily_prescribe_info,
        ...daily_prescribe_info_last,
        a_ymd: strFunc.getNumber2(opt_obj["date_str"]),
        a_seq: "",
        "a_write_date": opt_obj["date_str"],
        last_info: daily_prescribe_info_last
      };
    }

    return daily_prescribe_info;
  }

  static get_tstu_todo_of_subject(inData: any) {
    let opt_obj = {
      stu_info: null,
      date_str: "",
      pre_date_str: "",
      subject: "",
      user: {},
      writer_seq: "",
      writer_name: "",
      ...inData
    };
    let user = opt_obj["user"];
    let stu_info = opt_obj["stu_info"];

    let tstu_todo_info = TStuTodoBaseFunc.get_default_row_data({
      date_str: opt_obj["date_str"],
      user: user,
      row_data: {
        a_reserve_date: opt_obj["date_str"],
        a_mcomp_stu_seq: stu_info["a_seq"],
        a_stu_name: stu_info["a_user_name"],
        a_subject_name: opt_obj["subject"],
        a_par_id: "daily_report",
        a_par_seq: "",
        a_title: "데일리플랜",
      },
    });

    if (!strFunc.is_empty(opt_obj["writer_seq"])) {
      tstu_todo_info["a_writer_mcomp_user_seq"] = opt_obj["writer_seq"];
    }
    if (!strFunc.is_empty(opt_obj["writer_name"])) {
      tstu_todo_info["a_writer_name"] = opt_obj["writer_name"];
    }
    if (strFunc.is_empty(opt_obj["a_writer_seq"]) && user) {
      tstu_todo_info["a_writer_mcomp_user_seq"] = user.user_seq;
      tstu_todo_info["a_writer_name"] = user.user_name;
    }

    let is_exist_pre = false;
    if (stu_info.tstu_todo_arr && stu_info.tstu_todo_arr.length > 0) {
      for (let i = 0; i < stu_info.tstu_todo_arr.length; i++) {
        let row_tstu_todo_info = stu_info.tstu_todo_arr[i];
        if (row_tstu_todo_info["a_mcomp_stu_seq"] == stu_info["a_seq"]
          && row_tstu_todo_info["a_subject_name"] == opt_obj["subject"]
          && row_tstu_todo_info["a_is_success"] != "1") {
          if (is_exist_pre == false) {
            tstu_todo_info = {
              ...tstu_todo_info,
              ...row_tstu_todo_info,
            };
          }
          is_exist_pre = true;
        }
      }
      //오늘중에 있다면 가져온다.
      if (is_exist_pre == false) {
        for (let i = 0; i < stu_info.tstu_todo_arr.length; i++) {
          let row_tstu_todo_info = stu_info.tstu_todo_arr[i];
          if (row_tstu_todo_info["a_mcomp_stu_seq"] == stu_info["a_seq"]
            && row_tstu_todo_info["a_subject_name"] == opt_obj["subject"]
            && row_tstu_todo_info["a_reserve_date"] == opt_obj["date_str"]) {
            if (is_exist_pre == false) {
              tstu_todo_info = {
                ...tstu_todo_info,
                ...row_tstu_todo_info,
              };
            }
            is_exist_pre = true;
          }
        }
      }
    }

    return tstu_todo_info;
  }

  static get_stu_list_of_attend_data_setting(inData: any) {
    let opt_obj = {
      info_arr: [],
      ...inData
    };
    let info_arr = opt_obj.info_arr;

    for (let i = 0; i < info_arr.length; i++) {
      let info = info_arr[i];
      let attend_in_info: any = null;
      if (info.attend_in_arr && info.attend_in_arr.length > 0) {
        attend_in_info = info.attend_in_arr[0];
      }
      let attend_out_info: any = null;
      if (info.attend_out_arr && info.attend_out_arr.length > 0) {
        attend_out_info = info.attend_out_arr[0];
      }

      let attend_color = "#8d8d8d";
      let attend_text_color = "#fff";
      let attend_color_arr = [
        { "value": "attend", "text": "등원", color: "#eab358" },
        { "value": "late", "text": "등원(지각)", color: "#ea880b" },
        { "value": "absent", "text": "결석", color: "#f26b6f" },
        { "value": "out", "text": "하원", color: "#53a500" },
      ];
      if (attend_in_info != null) {
        for (let i = 0; i < attend_color_arr.length; i++) {
          if (attend_in_info["a_sort_detail"] == attend_color_arr[i]["value"]) {
            attend_color = attend_color_arr[i]["color"];
            if (attend_in_info["a_sort_detail"] == "attend") {
              attend_text_color = "#000000";
            }
          }
        }
      }
      if (attend_out_info != null) {
        for (let i = 0; i < attend_color_arr.length; i++) {
          if (attend_out_info["a_sort_detail"] == attend_color_arr[i]["value"]) {
            attend_color = attend_color_arr[i]["color"];
            attend_text_color = "#fff";
          }
        }
      }

      let attend_state_str = "미등원";
      let attend_memo = "";
      let attend_time = "00:00";
      let attend_out_time = "00:00";
      let attend_is_absent = false;
      if (attend_in_info != null) {
        attend_memo = attend_in_info["a_memo"];
        attend_time = attend_in_info["a_time"].substring(0, 5);
        let a_sort_detail = attend_in_info["a_sort_detail"];

        if (attend_out_info != null) {
          attend_out_time = attend_out_info["a_time"].substring(0, 5);
          a_sort_detail = attend_out_info["a_sort_detail"];
        }
        for (let i = 0; i < attend_color_arr.length; i++) {
          let item = attend_color_arr[i];
          if (item.value == a_sort_detail) {
            attend_state_str = item.text;
          }
        }

      }
      if (attend_state_str == "등원") {
        attend_state_str = "등원완료";
        attend_state_str = attend_time;
      }
      if(attend_state_str == "결석"){
        attend_is_absent = true;
      }

      info_arr[i]["attend_in_info"] = attend_in_info;
      info_arr[i]["attend_out_info"] = attend_out_info;
      info_arr[i]["attend_color"] = attend_color;
      info_arr[i]["attend_text_color"] = attend_text_color;
      info_arr[i]["attend_state_str"] = attend_state_str;
      info_arr[i]["attend_memo"] = attend_memo;
      info_arr[i]["attend_time"] = attend_time;
      info_arr[i]["attend_out_time"] = attend_out_time;
      info_arr[i]["attend_is_absent"] = attend_is_absent;
    }

    return info_arr;
  };

  static get_last_daily_info_by_lecture(inData: any) {
    return DailyReportDataFunc.get_last_daily_info_by_lecture(inData);
  }
  static get_daily_info_of_date(inData: any) {
    return DailyReportDataFunc.get_daily_info_of_date(inData);
  };
  static get_daily_percent(inData: any) {
    let opt_obj = {
      daily_info: {},
      is_sub: false,//sub
      ...inData
    };
    let daily_info = opt_obj["daily_info"];
    let daily_percent = 0;
    let a_todo_amount = parseInt(strFunc.uncomma(daily_info["a_todo_amount"]));
    let a_todo_success_amount = parseInt(strFunc.uncomma(daily_info["a_todo_success_amount"]));
    if (opt_obj.is_sub) {
      a_todo_amount = parseInt(strFunc.uncomma(daily_info["a_todo_sub_amount"]));
      a_todo_success_amount = parseInt(strFunc.uncomma(daily_info["a_todo_sub_success_amount"]));
    }

    if (a_todo_amount != 0 && a_todo_success_amount != 0) {
      daily_percent = Math.floor((a_todo_amount / a_todo_success_amount) * 100);
    }
    if (daily_percent > 100) { daily_percent = 100; }
    return daily_percent;
  }
  static get_stu_info_arr_of_update_daily_info(inData: any) {
    let opt_obj = {
      info_arr: [],
      update_daily_report_arr: [],
      ...inData
    };
    let info_arr = opt_obj.info_arr;
    let update_daily_report_arr = opt_obj.update_daily_report_arr;

    for (let daily_i = 0; daily_i < update_daily_report_arr.length; daily_i++) {
      let daily_info = update_daily_report_arr[daily_i];
      for (let i = 0; i < info_arr.length; i++) {
        let info = info_arr[i];
        if (info["a_seq"] == daily_info["a_stu_seq"]) {
          if (strFunc.is_empty(info["daily_report_arr"])) {
            info["daily_report_arr"] = [];
          }
          let is_exist = false;
          for (let j = 0; j < info["daily_report_arr"].length; j++) {
            let pre_daily_info = info["daily_report_arr"][j];
            if (pre_daily_info["a_lecture_seq"] == daily_info["a_lecture_seq"]
              && pre_daily_info["a_date"] == daily_info["a_date"]
              && pre_daily_info["a_lecture_time"] == daily_info["a_lecture_time"]
              && pre_daily_info["a_subject"] == daily_info["a_subject"]) {
              info["daily_report_arr"][j] = daily_info;
              is_exist = true;
            }
          }
          if (!is_exist) {
            info["daily_report_arr"].push(daily_info);
          }
        }
      }
    }

    return info_arr;
  };
  static get_stu_info_arr_of_update_daily_prescribe(inData: any) {
    let opt_obj = {
      info_arr: [],
      update_daily_prescribe_arr: [],
      ...inData
    };
    let info_arr = opt_obj.info_arr;
    let update_daily_prescribe_arr = opt_obj.update_daily_prescribe_arr;

    for (let daily_i = 0; daily_i < update_daily_prescribe_arr.length; daily_i++) {
      let prescribe_info = update_daily_prescribe_arr[daily_i];
      for (let i = 0; i < info_arr.length; i++) {
        let info = info_arr[i];
        if (info["a_seq"] == prescribe_info["a_stu_seq"]) {
          if (strFunc.is_empty(info["daily_prescribe_arr"])) {
            info["daily_prescribe_arr"] = [];
          }
          let is_exist = false;
          for (let j = 0; j < info["daily_prescribe_arr"].length; j++) {
            let pre_prescribe_info = info["daily_prescribe_arr"][j];
            if (pre_prescribe_info["a_stu_seq"] == prescribe_info["a_stu_seq"]
              && pre_prescribe_info["a_date"] == prescribe_info["a_date"]
              && pre_prescribe_info["a_subject"] == prescribe_info["a_subject"]) {
              info["daily_prescribe_arr"][j] = prescribe_info;
              is_exist = true;
            }
          }
          if (!is_exist) {
            info["daily_prescribe_arr"].push(prescribe_info);
          }
        }
      }
    }

    return info_arr;
  };
  static get_stu_info_arr_of_update_tstu_todo(inData: any) {
    let opt_obj = {
      info_arr: [],
      update_tstu_todo_arr: [],
      ...inData
    };
    let info_arr = opt_obj.info_arr;
    let update_tstu_todo_arr = opt_obj.update_tstu_todo_arr;

    for (let daily_i = 0; daily_i < update_tstu_todo_arr.length; daily_i++) {
      let update_tstu_todo = update_tstu_todo_arr[daily_i];
      for (let i = 0; i < info_arr.length; i++) {
        let info = info_arr[i];
        if (info["a_seq"] == update_tstu_todo["a_mcomp_stu_seq"]) {
          if (strFunc.is_empty(info["tstu_todo_arr"])) {
            info["tstu_todo_arr"] = [];
          }
          let is_exist = false;
          for (let j = 0; j < info["tstu_todo_arr"].length; j++) {
            let pre_prescribe_info = info["tstu_todo_arr"][j];
            if (pre_prescribe_info["a_stu_seq"] == update_tstu_todo["a_stu_seq"]
              && pre_prescribe_info["a_subject_name"] == update_tstu_todo["a_subject_name"]
              && pre_prescribe_info["a_is_success"] != "1") {
              if (is_exist == false) {
                info["tstu_todo_arr"][j] = update_tstu_todo;
                is_exist = true;
              }
            }
          }
          if (!is_exist) {
            info["tstu_todo_arr"].push(update_tstu_todo);
          }
        }
      }
    }

    return info_arr;
  };
  static get_stu_info_arr_of_update_study_title_arr(inData: any) {
    let opt_obj = {
      info_arr: [],
      study_title_arr: [],
      ...inData
    };
    let info_arr = opt_obj.info_arr;
    let study_title_arr = opt_obj.study_title_arr;
    let this_obj = this;

    for (let title_i = 0; title_i < study_title_arr.length; title_i++) {
      let title_info = study_title_arr[title_i];
      for (let i = 0; i < info_arr.length; i++) {
        let info = info_arr[i];
        if (info["daily_report_arr"]) {
          let is_exist_title = false;
          let tmp_daily_study_title_arr: any = [];
          for (let j = 0; j < info["daily_report_arr"].length; j++) {
            let daily_info = info["daily_report_arr"][j];
            if (daily_info["a_textbook_seq"] == title_info["a_seq"]) {
              tmp_daily_study_title_arr.push(title_info);
              is_exist_title = true;
            }
            if (daily_info["a_subtextbook_seq"] == title_info["a_seq"]) {
              tmp_daily_study_title_arr.push(title_info);
              is_exist_title = true;
            }
          }
          if (is_exist_title) {
            if (info["daily_study_title_arr"]) {
              info_arr[i]["daily_study_title_arr"] = this_obj.get_sum_two_study_title_arr({
                study_title_arr1: info["daily_study_title_arr"],
                study_title_arr2: tmp_daily_study_title_arr
              });
            } else {
              info_arr[i]["daily_study_title_arr"] = tmp_daily_study_title_arr;
            }
          } else {
            //info_arr[i]["daily_study_title_arr"]=[];
          }
        }
      }
    }

    return info_arr;
  };
  //두줄 합치기
  static get_sum_two_study_title_arr(inData: any) {
    let opt_obj = {
      study_title_arr1: [],
      study_title_arr2: [],
      ...inData
    };
    let study_title_arr = [...opt_obj.study_title_arr1];
    let study_title_arr2 = opt_obj.study_title_arr2;

    for (let i = 0; i < study_title_arr2.length; i++) {
      let title_info2 = study_title_arr2[i];
      let is_exist = false;
      for (let j = 0; j < study_title_arr.length; j++) {
        let title_info = study_title_arr[j];
        if (title_info["a_seq"] == title_info2["a_seq"]) {
          is_exist = true;
        }
      }
      if (is_exist == false) {
        study_title_arr.push(title_info2);
      }
    }

    return study_title_arr;
  };
}
export default DailyDataFunc;